import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import {
	deleteCookie,
	formAddCsrfProtection,
	getCookie,
	setCookie,
} from "../common/utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// notizie extra
	document.addEventListener("usernavready", () => {
		if (document.querySelector("#user_nav #_user_panel_container")) {
			for (const el of document.querySelectorAll("._extra-content")) {
				el.classList.add("d-none");
			}
		}
	});

	// contenuti con affiliazione
	let hideAffiliationsCookieName = "";
	const hideAffiliations = document.querySelector("#_hide-affiliate-button");
	if (hideAffiliations) {
		if (
			!!document.querySelector("#login_registration_container") &&
			!!document.querySelector("#user_nav #_user_panel_container") === false
		) {
			window.globalLoginWindowHandler.hideAffiliationsLogin(hideAffiliations);
		}
		const hideAffiliationsCheck = document.querySelector(
			"#_hide-affiliate-checkbox",
		);
		const hideAffiliationsLabel = document.querySelector(
			"label[for='_hide-affiliate-checkbox']",
		);
		hideAffiliationsCookieName = `aff-hide-${hideAffiliations.dataset.platform}`;
		if (getCookie(hideAffiliationsCookieName) === "1") {
			hideAffiliationsCheck.setAttribute("checked", "checked");
			hideAffiliationsLabel.classList.add("text-primary");
			for (const el of document.querySelectorAll("._hide-affiliate")) {
				el.classList.add("d-none");
			}
		}
		hideAffiliations.addEventListener("click", (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
			let hide = false;
			if (getCookie(hideAffiliationsCookieName) === "1") {
				hide = false;
				hideAffiliationsCheck.removeAttribute("checked", "checked");
				hideAffiliationsLabel.classList.remove("text-primary");
				deleteCookie(hideAffiliationsCookieName);
			} else {
				hide = true;
				hideAffiliationsCheck.setAttribute("checked", "checked");
				hideAffiliationsLabel.classList.add("text-primary");
				setCookie(hideAffiliationsCookieName, "1", 2);
			}
			for (const el of document.querySelectorAll("._hide-affiliate")) {
				el.classList.toggle("d-none");
			}
		});
	}

	if (document.querySelector("#_show_more_multicol")) {
		document
			.querySelector("#_show_more_multicol")
			.addEventListener("click", (e) => {
				e.preventDefault();
				for (const el of document.querySelectorAll(".endless_more")) {
					el.click();
				}
			});
	}
	endlessPaginate({
		moreSelector: "span.endless_more",
		moreSelectorDataUrl: "data-more",
		onCompleted: () => {
			// desktop
			if (document.querySelector("#_articles_column")) {
				if (
					!!document
						.querySelector("#_articles_column")
						.querySelector(".endless_more") === false ||
					!!document
						.querySelector("#_news_column")
						.querySelector(".endless_more") === false
				) {
					document
						.querySelector("#_show_more_multicol")
						.classList.add("d-none");
					document
						.querySelector("#_news_archive_link")
						.classList.remove("d-none");
				}
			}
			// notizie extra
			if (document.querySelector("#user_nav #_user_panel_container")) {
				for (const el of document.querySelectorAll("._extra-content")) {
					el.classList.add("d-none");
				}
			}
			// contenuti con affiliazione
			if (getCookie(hideAffiliationsCookieName) === "1") {
				for (const el of document.querySelectorAll("._hide-affiliate")) {
					el.classList.toggle("d-none");
				}
			}
		},
	});

	// Segnala errore alla redazione
	if (document.querySelector("#_staff_error_report")) {
		if (
			!!document.querySelector("#login_registration_container") &&
			!!document.querySelector("#user_nav #_user_panel_container") === false
		) {
			window.globalLoginWindowHandler.staffErrorReportLogin(
				document.querySelector("#_staff_error_report"),
			);
		}

		document
			.querySelector("#_staff_error_report input[type='button']")
			.addEventListener("click", (event) => {
				event.preventDefault();
				event.stopImmediatePropagation();
				const reportForm = document.querySelector("#_staff_error_report");
				const errorMessage = document.querySelector(
					"#_staff_error_report_message",
				);
				errorMessage.setAttribute("class", "");
				errorMessage.innerHTML = "";

				formAddCsrfProtection(reportForm).then((data) => {
					const formData = new FormData(reportForm);
					fetch(reportForm.getAttribute("action"), {
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
						method: "POST",
						cache: "no-cache",
						body: formData,
					})
						.then((response) => response.json())
						.then((data) => {
							if (data[0].message) {
								if (data[0].error) {
									errorMessage.classList.add("alert", "alert-danger");
								} else {
									errorMessage.classList.add("alert", "alert-success");
									reportForm.classList.add("d-none");
								}
								errorMessage.innerHTML = data[0].message;
							}
						})
						.catch((error) => {
							console.warn(" --- Error: ", error);
						});
				});
			});
	}
});
